import { CurbZonesResponse, OnStreetParkingStatsParam, SearchCurbZoneInput } from "services/web/api-curb-zone.type";
import { useCallback, useState } from "react";

import { CURB_ZONES_STATS_QUERY } from "@/services/web/api-curb-zone.const";
import { useQuery } from "@apollo/client/react";

export const useOnstreetParkingStats = () => {
  const [fetchingCurbZones, setFetchingCurbZones] = useState<boolean>(false);
  const [param, setParam] = useState<SearchCurbZoneInput>({ cityId: "" });

  const { data: { curbZones } = { curbZones: [] }, loading: loadingCurbZones = true } = useQuery<
    CurbZonesResponse,
    { filterInput: SearchCurbZoneInput }
  >(CURB_ZONES_STATS_QUERY, {
    variables: {
      filterInput: { cityId: param.cityId, policies: param.policies },
    },
    skip: !fetchingCurbZones,
  });

  const getParkingStats = useCallback(({ cityId, policyId }: OnStreetParkingStatsParam) => {
    if (policyId) {
      setParam({
        cityId: cityId,
        policies: [policyId],
      });
    } else {
      setParam({
        cityId: cityId,
      });
    }
    setFetchingCurbZones(true);
  }, []);

  return {
    getParkingStats,
    curbZones,
    isLoadingCurbZones: loadingCurbZones,
  };
};
